import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Headline = ({ header, title, image, className, appIdVisible }) => (
  <div className={cn('headline', className, appIdVisible && 'appIdVisible')}>
    {
      image && <img src={image} alt="LendingUSA" />
    }
    <h1>{header}</h1>
    <p>{title}</p>
  </div>
);

Headline.propTypes = {
  image: PropTypes.any,
  header: PropTypes.node.isRequired,
  title: PropTypes.node,
  className: PropTypes.string,
  appIdVisible: PropTypes.bool,
};

Headline.defaultProps = {
  title: '',
  image: null,
  className: '',
  appIdVisible: false,
};

export default Headline;
